import React from 'react';
import PropTypes from 'prop-types';
import './AmexGDAB2BHero.scss';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';

const AmexGDAB2BHero = ({
  baseRequestUrl,
  contentData: {
    heading,
    description,
    images: {
      regular: regularImage,
      retina: retinaImage,
    },
    logo,
    logo_aria: logoAria,
  },
}) => {
  const devicePixelRatio2x = (typeof window.matchMedia === 'function' && window.matchMedia('(-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 1.5dppx)').matches);
  const sanitizedHeading = sanitizeString(heading);
  const sanitizedDescription = sanitizeString(description);

  let heroImage = '';

  if (devicePixelRatio2x) {
    heroImage = retinaImage;
  } else {
    heroImage = regularImage;
  }

  return (
    <section className="AmexGDAB2BHero container">
      <div className="AmexGDAB2BHero__wrapper">
        <div className="AmexGDAB2BHero__content">
          <img
            className="AmexGDAB2BHero__logo"
            src={`${baseRequestUrl}AmexGDAB2B/logos/${logo}`}
            alt={logoAria}
          />
          <h1
            className="AmexGDAB2BHero__content--heading"
            dangerouslySetInnerHTML={{
              __html: sanitizedHeading,
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: sanitizedDescription,
            }}
          />
        </div>
        <div className="AmexGDAB2BHero__image">
          <div
            className="AmexGDAB2BHero__image--overlay"
            style={{
              backgroundImage: `url(${baseRequestUrl}AmexGDAB2B/images/${heroImage})`,
            }}
          />
          <img src={`${baseRequestUrl}AmexGDAB2B/images/${heroImage}`} alt="" />
        </div>
      </div>
    </section>
  );
};
AmexGDAB2BHero.propTypes = {
  baseRequestUrl: PropTypes.string.isRequired,
  contentData: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    images: PropTypes.shape({
      regular: PropTypes.string.isRequired,
      retina: PropTypes.string.isRequired,
    }),
    logo: PropTypes.string.isRequired,
    logo_aria: PropTypes.string.isRequired,
  }).isRequired,
};

export default AmexGDAB2BHero;
